import { useEffect, useState } from "react";
import { Locale } from "../types/locales";

/**
 * Hook to get the current shipping country from sessionStorage,
 * and reactively update it when a custom event is dispatched.
 * @param locale - fallback locale used to derive default country
 */
const useShippingCountry = (locale: string | Locale) => {
  const [country, setCountry] = useState(() => {
    const storedCountry = sessionStorage.getItem("defaultShippingEstimateCountry");
    return storedCountry || locale.split("-")[1];
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedCountry = sessionStorage.getItem("defaultShippingEstimateCountry");

      if (updatedCountry && updatedCountry !== country) {
        setCountry(updatedCountry);
      }
    };

    window.addEventListener("session-storage-country-changed", handleStorageChange);

    return () => {
      window.removeEventListener("session-storage-country-changed", handleStorageChange);
    };
  }, [country]);

  return country.toUpperCase();
};

export { useShippingCountry };
